import * as React from "react";

import { HideHelpWidget, UndoHideHelpWidget } from "../common";

import { usePlpPresenterForTheFilterMenu_Mobile } from "../providers";

import { Content } from "./Content";
import { ActionBar } from "./ActionBar";

export const MobileFilterMenu: React.FunctionComponent = () => {
  const { shouldShowTheFilterMenu_onMobile, handleHideTheFilterMenu_onMobile } =
    usePlpPresenterForTheFilterMenu_Mobile();

  const modalRef = React.useRef<HTMLDivElement>(null);

  const [presentingAnimationClass, setPresentingAnimationClass] =
    React.useState(false);

  const present = () => {
    document.body.classList.add("bbnt-modal-visible-scroll-that-only");

    HideHelpWidget();

    modalRef.current?.focus();
  };

  const forceClose = () => {
    setPresentingAnimationClass(false);
    handleHideTheFilterMenu_onMobile();
    document.body.classList.remove("bbnt-modal-visible-scroll-that-only");
    UndoHideHelpWidget();
  };

  const onClose = () => {
    setPresentingAnimationClass(false);
    setTimeout(() => {
      forceClose();
    }, 299);
  };

  React.useEffect(() => {
    if (shouldShowTheFilterMenu_onMobile) {
      present();
      window.requestAnimationFrame(() => {
        if (!presentingAnimationClass) {
          setPresentingAnimationClass(true);
        }
      });
    }
  }, [shouldShowTheFilterMenu_onMobile]);

  React.useEffect(() => {
    const handleResize = () => {
      if (window.matchMedia("(min-width: 1024px)").matches) {
        forceClose();
      }
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
      forceClose();
    };
  }, []);

  return (
    <aside
      className={`modal filter ${presentingAnimationClass ? "present" : ""}`}
      ref={modalRef}
    >
      <Content onClose={onClose} />
      <ActionBar onClose={onClose} />
    </aside>
  );
};
